import PermissionsProvider from "./PermissionsProvider";

export default PermissionsProvider;
